import { UPDATE_AI_REPORTS } from '../actions/types';

const initialState = {
  aiReportsMasterMap: undefined,
  aiReportsMapBounds: null,
  isAddNewLocationPanelActive: false,
  newCreatedPlace: {},
  selectedActiveSearchPlace: {},
  isAddLocationMapActive: false,
};

const aiReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AI_REPORTS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default aiReportsReducer;
